import multiguard from 'vue-router-multiguard';
import Login from '@/views/login.vue';
import Forgot from '@/views/forgot.vue';
import Confirm from '@/views/confirm.vue';
import Tos from '@/views/tos.vue';
import Mfa from '@/views/mfa.vue';
// import Signup from '@/views/signup.vue';
import Dashboard from '@/views/dashboard/dashboard.vue';
import Profile from '@/views/profile.vue';
import Devices from '@/views/devices/devices.vue';
import Keys from '@/views/keys/keys.vue';
import Support from '@/views/support.vue';
import NotFound from '@/views/not-found.vue';
import ManageDiode from '@/views/admin/diodes/manage-diode.vue';
import ManageDiodes from '@/views/admin/diodes/manage-diodes.vue';
import ManageUsers from '@/views/admin/users/manage-users.vue';
import guards from './guards';


const protect = multiguard([guards.authenticated, guards.loaded, guards.terms]);
const subscriber = multiguard([guards.authenticated, guards.loaded, guards.terms, guards.subscriber]);
const admin = multiguard([guards.authenticated, guards.admin, guards.loaded]);

// routes (almost every route should have *some* guard to at least load the csrf cookie or something)
export default [
  {
    path: '/login',
    component: Login,
    beforeEnter: guards.open
  },
  {
    path: '/mfa',
    component: Mfa,
    beforeEnter: guards.open
  },
  {
    path: '/forgot',
    component: Forgot,
    beforeEnter: guards.open
  },
  {
    path: '/confirm',
    component: Confirm,
    beforeEnter: guards.open
  },
  {
    path: '/terms',
    component: Tos,
    beforeEnter: guards.open
  },
  {
    path: '/',
    alias: '/dashboard',
    component: Dashboard,
    beforeEnter: protect
  },
  {
    path: '/profile',
    component: Profile,
    beforeEnter: protect
  },
  {
    path: '/devices',
    component: Devices,
    beforeEnter: subscriber
  },
  {
    path: '/keys',
    component: Keys,
    beforeEnter: subscriber
  },
  {
    path: '/support',
    component: Support,
    beforeEnter: protect
  },
  {
    path: '/manage/diodes',
    component: ManageDiodes,
    beforeEnter: admin
  },
  {
    name: 'diode',
    path: '/manage/diode/:serial',
    component: ManageDiode,
    beforeEnter: admin
  },
  {
    path: '/manage/users',
    component: ManageUsers,
    beforeEnter: admin
  },
  {
    path: '/notfound',
    component: NotFound
  },
  {
    path: '*',
    redirect: '/notfound'
  },
];
